let t = "http://img.fengbolive.com/pic/avatar/{0}_{1}_200*200.jpg"
let ANCHOR_SORT_BASE = 100

const state = {
    resultList: [],
    key:'',
    Page:1,
    countPerPage:30,
    totleCount:0,
}

// this message is similar to send message. It's sync
const mutations = {
    SEARCH_RESULT_UPDATE_ANCHORLIST(state, data) {
        if (null == data) {
            state.resultList = [];
            state.Page = 1
            state.totleCount = 0;
            return;
        }
        let ls = state.resultList;
        let lsSrc = data.list;
        let info, url = null;
        for (let i = 0; i < lsSrc.length; i++) {
            info = lsSrc[i];
            if (info.photo_num == 0) {
                info['img'] = "http://img.fengbolive.com/pic/avatar/default.png";
            } else if(info.photo_num == 1){
                info['img'] = "http://img.fengbolive.com/pic/avatar/smallHeadForAuthFail.png";
            } else {
                info['img'] = t.format(info.user_id, info.photo_num);
            }
            info['name'] = info.nick_nm;
            ls.push(info);
        }
    },
    SEARCH_RESULT_UPDATE_KEY(state, data) {
        state.key = data
    },
    SEARCH_RESULT_UPDATE_PAGE(state, data) {
        state.Page = data
    },
    SEARCH_RESULT_UPDATE_TOTLE(state, data) {
        state.totleCount = data
    },
}

// this message is similar to post message. It's async
const actions = {
    upDataSearchResultListData({
        state,
        commit
    },
    data){
        commit('SEARCH_RESULT_UPDATE_ANCHORLIST', data)
    },
    upDataSearchKey({
        state,
        commit
    },
    data){
        commit('SEARCH_RESULT_UPDATE_KEY', data)
    },
    upDataSearchResultPage({
        state,
        commit
    },
    data){
        commit('SEARCH_RESULT_UPDATE_PAGE', data)
    },
}

const getters = {
}

export default {
    state,
    mutations,
    actions,
    getters
}